<template>
  <section :class="'bolaopage-options lot-'+lotterySlug+'-bg'">

    <span class="bolaopage-options__shadow"></span>

    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="bolaopage-options__wrap" v-if="loaded && product">
            <div class="bolaopage-options__head">
              <h1 class="bolaopage-options__head__sup m-0">
                Bolão disponível
              </h1>
              <div class="bolaopage-options__head__title" v-text="items.length+' '+(items.length === 1 ? 'opção de jogo' : 'opções de jogos')"></div>
              <div class="bolaopage-options__head__help">
                <button class="btn-info btn-info--white" v-tooltip="{ content: 'Alterne entre as Opções de Jogo abaixo para visualizar as dezenas utilizadas em cada uma delas. Todas foram construídas com a mesma estratégia, mas você pode escolher a combinação de sua preferência.' }">
                  <i class="fa fa-question"></i>
                </button>
              </div>

            </div>

            <div class="bolaopage-options__list">
              <ul>
                <li v-for="item,index in items"
                :key="`bolaopage-options__list-item-${index}`"
                v-bind:class="{'active' : index === selectedIndex }">
                  <button class="lot-color" v-text="item.serie" v-on:click="setItem(index)"></button>
                </li>
              </ul>
            </div>

            <div class="bolaopage-options__cards">

              <div class="bolaopage-options__cards__wrap">
                <div class="modal--jogo__cards__header" v-if="cardsLoaded">
                  <div>
                    <button
                    v-if="pagination.HasPrevious"
                      v-on:click="getCards('-')"
                      class="btn btn-invert btn-icon btn-lot d-lg-none"
                    >
                      <i class="fa fa-chevron-left"></i>
                    </button>
                  </div>

                  <div>
                    <strong
                      v-if="pagination"
                      v-text="
                        (pagination.TotalCount < 10 ? '0' : '') +
                        '' +
                        pagination.TotalCount +
                        ' ' +
                        (pagination.TotalCount === 1 ? 'Aposta' : 'Apostas')
                      "
                    ></strong>
                  </div>

                  <div>
                    <button
                      v-if="pagination.HasNext"
                      v-on:click="getCards('+', null, true)"
                      class="btn btn-invert btn-icon btn-lot d-lg-none"
                    >
                      <i class="fa fa-chevron-right"></i>
                    </button>
                  </div>
                </div>

                <div v-if="!cardsLoaded" class="text-center p-3">
                  <span class="mr-1"><i class="fa fa-refresh fa-spin"></i></span>
                  <span>Carregando apostas...</span>
                </div>

                <div v-if="cardsLoaded && !cards" class="p-3">
                  <div class="alert alert--error text-center">
                    <p>Nenhuma aposta encontrada.</p>
                    <button class="btn btn-white btn-small" v-on:click="setItem(selectedIndex)">
                      <i class="fa fa-refresh color-primary"></i> Tentar Novamente
                    </button>
                  </div>
                </div>

                <div class="bolaopage-options__cards__list" v-if="cardsLoaded && cards">

                  <div
                    v-for="(card, index) in cards"
                    :key="`modal--jogo__card-${index}`"
                    class="modal--jogo__card" v-bind:class="{ 'lot-bg-light lot-border-light': card.betNumber === betNumber }">
                    <div v-text="card.betNumberFormatted" class="modal--jogo__card__number"></div>

                    <div class="modal--jogo__card__bet">
                      <div
                        class="modal--jogo__card__bet__tens"
                        v-if="card.gameType === 'tens'" >
                        <div class="modal--jogo__card__bet__tens__ten" v-for="n in card.betFormatted" :key="`modal--jogo__card__bet__tens-${n}`">
                          {{ n }}
                        </div>

                        <div
                          class="key"
                          v-if="card.key"
                        >
                          <i v-if="lotterySlug === 'dia-de-sorte'" class="fa fa-calendar"></i>
                          <i v-if="lotterySlug === 'timemania'" class="fa fa-heart"></i>
                          <span>{{ card.key }}</span>
                        </div>
                        <!-- /tens -->
                      </div>

                      <div class="modal--jogo__card__bet loteca" v-if="drawInfo.gameType === 'loteca' && drawInfo">
                        <div class="result__loteca-item" v-for="(itemLoteca, index) in drawInfo.footballScheme.matchList" :key="`result__loteca-item-${index}`">
                          <div class="lot-color">
                            <strong v-text="index + 1"></strong>
                          </div>
                          <div>
                            <span v-text="itemLoteca.homeTeam || ''"></span>
                          </div>
                          <div>
                            <div>
                              <div
                                class="result__loteca-item__option"
                                v-bind:class="{
                                  'lot-bg-light':
                                    card.betFormatted[index][0],
                                  'lot-bg':
                                    card.betFormatted[index][0],
                                }"
                              >
                                <span v-text="itemLoteca.homeGoals || 0"></span>
                              </div>
                            </div>
                            <div>
                              <div
                                class="result__loteca-item__option"
                                v-bind:class="{
                                  'lot-bg-light':
                                    card.betFormatted[index][1],
                                  'lot-bg':
                                    card.betFormatted[index][1],
                                }"
                              >
                                <span>x</span>
                              </div>
                            </div>
                            <div>
                              <div
                                class="result__loteca-item__option"
                                v-bind:class="{
                                  'lot-bg-light':
                                    card.betFormatted[index][2],
                                  'lot-bg':
                                    card.betFormatted[index][2],
                                }"
                              >
                                <span v-text="itemLoteca.awayGoals || 0"></span>
                              </div>
                            </div>
                          </div>
                          <div>
                            <span v-text="itemLoteca.awayTeam || ''"></span>
                          </div>
                        </div>

                        <div class="modal--jogo__card__bet__hints">
                          <div>
                            <span>Secos</span>
                            <strong class="lot-color">{{
                              getLotecaInfo(card.betFormatted).Secos
                            }}</strong>
                          </div>
                          <div>
                            <span>Duplos</span>
                            <strong class="lot-color">{{
                              getLotecaInfo(card.betFormatted).Duplos
                            }}</strong>
                          </div>
                          <div>
                            <span>Triplos</span>
                            <strong class="lot-color">{{
                              getLotecaInfo(card.betFormatted).Triplos
                            }}</strong>
                          </div>
                        </div>

                        <!-- /loteca -->
                      </div>

                      <div v-if="drawInfo.gameType === 'federal'" class="modal--jogo__card__bet federal" >
                        <div
                          v-for="n in card.betFormatted"
                          :key="`modal--jogo__card__bet-${n}`"
                          v-text="n"
                        ></div>
                        <!-- /federal -->
                      </div>

                      <div v-if="drawInfo.gameType === 'supersete'" class="modal--jogo__card__bet supersete">
                        <div class="modal--jogo__card__bet__column"
                          v-for="(column, index) in Object.values(
                            card.betFormatted
                          )"
                          :key="`modal--jogo__card__bet__column-${index}`"
                          >
                          <div class="lot-color">{{ index + 1 }}</div>
                          <div class="modal--jogo__card__bet__hints" v-if="column">
                            <span
                              v-for="n in column"
                              :key="`modal--jogo__card__bet__hints-${n}`"
                              v-text="n"
                            ></span>
                          </div>
                        </div>
                      </div>
                      <!-- /supersete -->
                    </div>
                  </div>

                </div>
                <!-- /.bolaopage-options__cards__list -->

                <div class="modal--jogo__cards__footer d-none d-lg-block" v-if="cardsLoaded && pagination && pagination.PageCount > 1" >
                  <ul class="pagination-cards">
                    <li v-if="pagination.HasPrevious">
                      <button
                        v-on:click="getCards('-', null, true)"
                        class="btn btn-square btn-small btn-invert btn-lot"
                      >
                        <i class="fa fa-chevron-left"></i>
                      </button>
                    </li>
                    <li v-for="(n, index) in formattedPages" :key="`modal--jogo__cards__footer-${index}`">
                      <button
                        v-on:click="getCards(n, null, true)"
                        class="btn btn-square btn-small btn-lot"
                        v-text="n"
                        v-bind:class="{ 'btn-invert': n !==pagination.CurrentPage }"
                      ></button>
                    </li>
                    <li v-if="pagination.HasNext">
                      <button
                        v-on:click="getCards('+', null, true)"
                        class="btn btn-square btn-small btn-invert btn-lot"
                      >
                        <i class="fa fa-chevron-right"></i>
                      </button>
                    </li>
                  </ul>
                </div>
                <!-- /.modal--jogo__cards__footer -->

              </div>
              <!-- /.bolaopage-options__cards__wrap -->

            </div>

          </div>
          <!-- /.bolaopage-options__wrap -->

        </div>
      </div>
    </div>

  </section>
</template>
<script>
import getCards from '@services/inventory/getCards';

export default {
  emits: ['selectitem'],
  data: function () {
    return {
      processing: false,
      page: 1,
      cardsLoaded: false,
      cards: null,
      formattedPages: [],
      pagination: null,
      betNumber: null,
      offset: 0
    };
  },
  props: {
    lotterySlug: {
      type: String
    },
    items: null,
    drawInfo: null,
    product: null,
    selectedIndex: Number
  },
  computed: {
    loaded () {
      return !!this.product && this.items && !!this.drawInfo;
    }
  },
  watch: {
    selectedIndex (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.betNumber = null;
        this.getCards(1, null);
      }
    },
    loaded (newVal, oldVal) {
      if (!oldVal && newVal) {
        this.fetch();
      }
    }
  },
  methods: {
    fetch () {
      this.getCards();
    },
    setItem (index) {
      this.$emit('selectitem', index)
    },
    checkEnter (ev) {
      if (ev.keyCode == 13) {
        this.getCards(1, this.betNumber);
      }
    },
    getCards (page = 1, betNumber = null, scroll = false) {
      if (!this.product || !this.items[this.selectedIndex]) {
        return;
      }

      if (betNumber && Number(betNumber) > this.pagination.TotalCount) {
        alert('Cartão não encontrado.');
        return;
      }

      if (
        betNumber &&
        document.querySelector('.modal--jogo__card.lot-bg-light')
      ) {
        this.$scrollTo(
          document.querySelector('.modal--jogo__card.lot-bg-light'),
          500,
          {
            container: 'body',
            offset: -Math.abs(this.offset)
          }
        );
        return;
      }

      if (scroll) {
        this.$scrollTo(document.querySelector('#opcoes'), 500, {
          container: 'body'
        });
      }

      if (page == '-') {
        page =
          this.pagination.CurrentPage - 1 < 1
            ? 1
            : this.pagination.CurrentPage - 1;
      }

      if (page == '+') {
        page =
          this.pagination.CurrentPage + 1 > this.pagination.PageCount
            ? this.pagination.PageCount
            : this.pagination.CurrentPage + 1;
      }

      const _self = this;

      _self.cardsLoaded = false;
      _self.cards = null;
      _self.formattedPages = [];

      const params = {
        productID: this.items[this.selectedIndex].id,
        categoryID: 1,
        pageSize: 10,
        lotteryID: this.drawInfo.lotteryID,
        isOrdered: false
      };

      if (!betNumber) {
        params.page = page || 1;
      } else {
        params.betNumber = betNumber;
      }

      getCards(params)
        .then((res) => {
          _self.pagination = res.pagination;
          _self.cards = res.cards;
          _self.cardsLoaded = true;

          _self.formattedPages.push(res.pagination.CurrentPage);

          for (let i = 1; i < 3; i++) {
            if (_self.pagination.CurrentPage - i < 1) {
              break;
            }
            _self.formattedPages.push(_self.pagination.CurrentPage - i);
          }

          _self.formattedPages.sort();

          const offset = 8 - _self.formattedPages.length;

          for (let i = 1; i <= offset; i++) {
            if (
              _self.pagination.CurrentPage + i >
              _self.pagination.PageCount
            ) {
              break;
            }
            _self.formattedPages.push(_self.pagination.CurrentPage + i);
          }

          setTimeout(() => {
            if (document.querySelector('.modal--jogo__card.lot-bg-light')) {
              this.$scrollTo(
                document.querySelector('.modal--jogo__card.lot-bg-light'),
                500,
                {
                  container: 'body',
                  offset: -Math.abs(this.offset)
                }
              );
            }
          }, 400);
        })
        .catch((err) => console.error(err));
    },
    getLotecaInfo (card) {
      const obj = {
        Secos: 0,
        Duplos: 0,
        Triplos: 0
      };

      Object.values(card).forEach((a) => {
        const selecteds = Object.values(a).filter((a) => a).length;

        switch (selecteds) {
          case 1:
            obj.Secos++;
            break;
          case 2:
            obj.Duplos++;
            break;
          case 3:
            obj.Triplos++;
            break;
        }
      });

      return obj;
    }
  },
  created () {
    this.offset += document.getElementById('header').offsetHeight;

    if (document.querySelector('.page-boloes-detail .page-nav')) {
      this.offset += document.querySelector(
        '.page-boloes-detail .page-nav'
      ).offsetHeight;
    }

    if (this.loaded) {
      this.fetch();
    }
  }
}
</script>
